import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import { formatAmount } from "../../app-core/_common/format/localization"
import { getPriceInfo, PriceInfo } from "../../app-core/_common/get-price-info"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { useReceiptReadModel } from "../../app-core/features/_common/machines/receipt-machine"

export type UseTotalPriceResponse =
    | {
          type: "price"
          formattedAmount: string
          formattedOriginalAmount: string | undefined
          price: PriceInfo
      }
    | { type: "loading"; formattedAmount: string; formattedOriginalAmount: string | undefined; price: PriceInfo }
    | undefined

type Args = {
    extendedLabel?: boolean
}

export const useTotalPrice = ({ extendedLabel }: Args): UseTotalPriceResponse => {
    const [state] = useECommerceMachine()
    const [stateRC] = useReceiptReadModel(state)
    const receiptIsLoading = stateRC.matches("loading")
    const hasPrice = (stateRC.matches("present") || stateRC.matches("loading")) && stateRC.context.receipt

    if (receiptIsLoading) {
        const price = getPriceInfo(stateRC.context.receipt, receiptIsLoading, extendedLabel)
        const formattedOriginalAmount = F.pipe(price.originalAmount, O.matchW(F.constUndefined, formatAmount))
        const formattedAmount = formatAmount(price.amount)

        return { type: "loading", formattedAmount: formattedAmount, formattedOriginalAmount, price }
    }

    if (!hasPrice) {
        return undefined
    }

    const price = getPriceInfo(stateRC.context.receipt, receiptIsLoading, extendedLabel)

    const formattedOriginalAmount = F.pipe(price.originalAmount, O.matchW(F.constUndefined, formatAmount))
    const formattedAmount = formatAmount(price.amount)

    return { type: "price", price, formattedAmount, formattedOriginalAmount }
}
